import { render, staticRenderFns } from "./EcPerType.vue?vue&type=template&id=2946a09c"
import script from "./EcPerType.vue?vue&type=script&lang=js"
export * from "./EcPerType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports